/* Only decorative coastal effects; no cart, variant, or gallery code is touched. */
(() => {
  if (window.sicAmbientInitialized) return;
  window.sicAmbientInitialized = true;
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = localStorage.getItem('sic-coastal-motion') === 'paused'; } catch (_) {}
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => entry.target.classList.toggle('sic-in-view', entry.isIntersecting));
  }, { threshold: .05 }) : null;
  function refresh() {
    root.classList.toggle('sic-motion-playing', !paused && !reduced.matches);
    document.querySelectorAll('[data-sic-motion-toggle]').forEach(button => {
      button.hidden = false;
      button.disabled = reduced.matches;
      button.textContent = reduced.matches ? 'Reduced motion is on' : paused ? 'Play coastal motion' : 'Pause coastal motion';
    });
  }
  function init(scope) {
    scope.querySelectorAll('[data-sic-motion]').forEach(element => {
      if (element.dataset.sicObserved) return;
      element.dataset.sicObserved = 'true';
      if (observer) observer.observe(element); else element.classList.add('sic-in-view');
    });
    refresh();
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-sic-motion-toggle]') || reduced.matches) return;
    paused = !paused;
    try { localStorage.setItem('sic-coastal-motion', paused ? 'paused' : 'playing'); } catch (_) {}
    refresh();
  });
  document.addEventListener('visibilitychange', () => root.classList.toggle('sic-page-hidden', document.hidden));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (observer) event.target.querySelectorAll('[data-sic-motion]').forEach(element => observer.unobserve(element));
  });
  if (reduced.addEventListener) reduced.addEventListener('change', refresh);
  else reduced.addListener(refresh);
  init(document);
  root.classList.toggle('sic-page-hidden', document.hidden);
})();
